'use strict';

import { commonFileMimesOfExt } from './constants';

export const getMimesFromExtArray = (extArray) => {
  return extArray.map((ext) => commonFileMimesOfExt[ext] || `.${ext}`).join(',');
};

export const pickLocalFiles = (accept, maxCount = 1) => {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';

    if (accept) {
      input.accept = getMimesFromExtArray(accept);
    }

    input.multiple = maxCount > 1;
    input.style.display = 'none';

    input.onchange = (e) => {
      const files = e.target.files;
      const slicedFiles = files ? Array.prototype.slice.call(files, 0) : [];
      const filterFiles = accept
        ? slicedFiles.filter((file) => {
            const ext = file.name.split('.').pop();

            if (!accept.includes(ext.toLowerCase())) {
              console.error('文件格式不支持', file.name);
              return false;
            }

            return true;
          })
        : slicedFiles;

      resolve(filterFiles);
    };

    input.click();
  });
};
